module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('list', {
    staticClass: "list-box p0002"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', {
    attrs: {
      "icon": "scan"
    }
  }, [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("带图标")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item list-item-arrow"
  }, [_c('menu-vertical', {
    attrs: {
      "icon": "cascades"
    }
  }, [_c('p', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("带图标箭头")])])], 1)]), _vm._v(" "), _c('list', {
    staticClass: "list-box p0002 m2000"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('p', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("右侧停靠")]), _vm._v(" "), _c('btn', {
    attrs: {
      "slot": "dock",
      "theme": "blank",
      "blank": "true",
      "name": "Anything"
    },
    slot: "dock"
  })], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', [_c('p', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("右侧停靠")]), _vm._v(" "), _c('i', {
    staticClass: "icon iconfont icon-roundcheckfill",
    staticStyle: {
      "font-size": "24px",
      "color": "#3492e6"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item list-item-arrow"
  }, [_c('menu-vertical', [_c('p', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("自定义内容 "), _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "13px",
      "color": "#999"
    }
  }, [_vm._v("随便怎么加")])])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-680a8e18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-vertical/demo.vue
// module id = 261
// module chunks = 11